import { Link } from 'react-router-dom';

import { CommonWrapper, ConfigWrapper } from '@kanda-libs/ks-design-library';

import HelpModal from 'components/HelpModal';

import Container from './AppWrapper-container';

import { URLS } from '../../config';

interface ViewComponentProps {
  /**
   * Children
   */
  children?: JSX.Element[] | JSX.Element;
}

const ViewComponent = ({ children }: ViewComponentProps) => (
  <ConfigWrapper
    linkComponent={Link as unknown as string}
    homeLinkProps={{ to: URLS.home }}
  >
    <CommonWrapper>
      <Container>{children}</Container>
      <HelpModal />
    </CommonWrapper>
  </ConfigWrapper>
);

ViewComponent.defaultProps = {
  children: null,
};

ViewComponent.displayName = 'AppWrapper-view';

export default ViewComponent;
